import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import React from 'react';
import FactorActionComponent from 'components/FactorActionComponent/FactorActionComponent';

const PaymentHistoryResourceModuleView = props => {
  const {
    history,
    paymentHistorySummaryAdditionalData,
    offer,
    selectedFactor,
    eventHandler,
    moduleHeading,
    moduleMetadata,
  } = props;
  const linkPath = 'https://smart.link/rbfe5mo56ankf';

  const delinquent =
    paymentHistorySummaryAdditionalData?.paymentHistorySummary
      ?.delinquentTradelineCount;

  const derogatory =
    paymentHistorySummaryAdditionalData?.paymentHistorySummary
      ?.derogatoryTradelineCount;

  if (delinquent + derogatory > 0) {
    return (
      <FlexContainer
        className={
          'flex-column margt20 border-rad8px marglr48 m-marglr16 system_ltblue_lb025'
        }
      >
        <FlexContainer className={'flex-column margtb10 marglr12'}>
          <Label type="Body-2 mBody-2" className={'margtb8'}>
            Check out our guide for help dealing with collection accounts.
          </Label>
          <FactorActionComponent
            text={
              'Check out your free guide “6 Steps to Deal With Your Collection Accounts”'
            }
            icon={'notificationIconGuide'}
            url={linkPath}
            history={history}
            offerModulePosition={1}
            selectedFactor={selectedFactor}
            offer={offer}
            isExternalPath
            eventHandler={eventHandler}
            moduleHeading={moduleHeading}
            moduleMetadata={moduleMetadata}
          />
        </FlexContainer>
      </FlexContainer>
    );
  } else {
    return <></>;
  }
};

export default PaymentHistoryResourceModuleView;
